// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__fSKHg","overlay":"Modal_overlay__sOUtR","content":"Modal_content__6UAG-","opened":"Modal_opened__OA71S","isClosing":"Modal_isClosing__H06Ux"};